import { FC } from 'react';
import { Layout, Typography } from 'antd';

const { Footer } = Layout;
const { Text } = Typography;

export const UnauthorizedFooter: FC = () => {
    return (
        <Footer style={{ textAlign: 'center', backgroundColor: 'transparent' }}>
            <Text>© 2025 MyBonum. All rights reserved.</Text>
        </Footer>
    );
};
